import { createAction, props } from '@ngrx/store';

import { Cow, FertilitySummary } from '../../models/fertility.model';

export const loadCowsByDateRequest = createAction(
  '[Fertility] Load fertility data of cows for specific date',
  props<{ date: string }>(),
);

export const loadCowsByDateSuccess = createAction(
  '[Fertility] Load fertility data of cows for specific date succeeded',
  props<{ date: string; cows: Cow[] }>(),
);

export const loadFertilitySummaryRequest = createAction(
  '[Fertility] Load fertility summary data for specific date',
  props<{ date: string }>(),
);

export const loadFertilitySummarySucces = createAction(
  '[Fertility] Load fertility summary data succeeded',
  props<{ date: string; fertilitySummary: FertilitySummary }>(),
);
